import React from 'react'

const Profile = () => {
    return (
        <div>
            <h2>Profile</h2>
        </div>
    )
}

export default Profile
